// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","FacetImage":"_3te1ZK","facetText":"Q3XFli","whiteUppercase":"_3KndZB","orangeTitlecase":"_1Fkh7x","primeFacet":"JV4BwB","fadeInFrames":"_2a4j1B"};